export const JD_UPLOAD_SUCCESSFULLY="JD has been uploaded"
export const RESUME_UPLOAD_SUCCESSFULLY="Resume has been uploaded"
export const DETAIL_UPDATED_SUCCESS="Details have been updated successfully"
export const BULK_IMPORT_SUCCESS="Data successfully imported"